export default function CommunityHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/f0b80746-80f3-43ef-a546-af710736dea0_shutterstock_2135457873.jpg?v=8d22899ab5a0c34c9cdc0bc530bf56e5"
          alt="CSCF families connecting and supporting each other through Cardiospondylocarpofacial syndrome"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-brand-900/70 via-brand-800/55 to-accent-900/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/6f9e6aa7-09db-4a9b-9ba0-39ddfb321c10_CSCF_Logo_ON_DARK_HORIZONTAL.png?v=acda9b505a48b061efb7c407bb65535c"
            alt="CSCF Support"
            className="h-12 w-auto object-contain opacity-90"
          />
        </div>

        <div className="inline-flex items-center px-5 py-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full mb-8">
          <i className="ri-group-line text-blue-200 mr-2 text-sm"></i>
          <span className="text-sm font-medium text-white/90 font-body">CSCF Support Community</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight font-heading">
          You Are Not Alone
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed font-body mb-10">
          Families, patients, caregivers, and researchers — all coming together around CSCF. Whatever stage you are at, there is a place for you here.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#connect"
            className="px-8 py-4 bg-white text-brand-600 font-bold rounded-full hover:bg-brand-50 transition-colors whitespace-nowrap cursor-pointer font-body flex items-center gap-2"
          >
            <i className="ri-heart-line"></i>
            Get Connected
          </a>
          <a
            href="#story-form"
            className="px-8 py-4 bg-white/15 backdrop-blur-sm border-2 border-white/40 text-white font-semibold rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer font-body"
          >
            Share Your Story
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-white/50"></i>
      </div>
    </section>
  );
}
